import React from "react";
import { FormField } from "Components/Shared/FormComponents/FormField/FormField";
import { TextFieldProps } from "@material-ui/core";
import AmountField from "Components/Shared/FormComponents/AmountField/AmountField";
import { usePartnerConfig } from "Hooks/usePartnerConfig";

export const BudgetField = (props: TextFieldProps) => {
  const { rewardsOptions } = usePartnerConfig();

  return (
    <FormField fieldName="Monthly Budget ($)">
      <AmountField
        name="budget"
        maxAmount={rewardsOptions?.maxMonthlyBudgetAmountCents}
        textFieldProps={props}
      />
    </FormField>
  );
};
